import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Aero1200AuthenticationTokenResponse } from 'src/app/models/1200aero/Aero1200AuthenticationTokenResponse';

@Injectable({
  providedIn: 'root'
})
export class Aero1200Service {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
      this.headers = new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
      });
      this.accessPointUrl = baseUrl + 'api/aero1200';
  }

  public getAuthenticationToken(fboId: number) {  
      return this.http.get<Aero1200AuthenticationTokenResponse>(`${this.accessPointUrl}/authenticationToken/${fboId}`, {
          headers: this.headers,
      });
  }
}
